/**
 * Initial roster used by every local party game. Hosts can freely rename,
 * remove, or add participants before creating a room.
 */
export const DEFAULT_PLAYER_NAMES = [
  'Леха',
  'Люба',
  'Саша',
  'Марина',
  'Костя Куд',
  'Катя',
  'Костя Кра',
  'Надя',
  'Виталя',
  'Оля',
] as const;
